var map = {
	"./batch.js": "G9i0",
	"./insurance.js": "h0Jx",
	"./order.js": "v0dB",
	"./policy.js": "Xfja",
	"./program.js": "xeUv",
	"./setting.js": "6PHh",
	"./statistics.js": "wmNF",
	"./tuan.js": "95pp"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "xwiA";


//////////////////
// WEBPACK FOOTER
// ./src/router/feiche nonrecursive ^(?!\.\/index|\.\/cockpit).*\.js$
// module id = xwiA
// module chunks = 225